import { httpRequest } from '../../../app/common/util/api-common.util';

export default class HistologiaApi {
  static getCassetes (tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc) {
    return httpRequest(
      `cassetes?tecnicoId=${tecnico}&dataInicio=${dataInicial}&dataFim=${dataFinal}&nrExame=${numeroDoExame}&numeropedido=${numeroDoPedido}&citologia=false&sortAsc=${sortAsc}`
    ).then(json => json.data);
  }

  static updateCassete (casseteID, status) {
    return httpRequest(
      `cassetes/${casseteID}/update/status/${status}`,
      'PATCH'
    ).then(json => json.data);
  }

  static getUsuario () {
    return httpRequest('segusu/histologia').then(json => json.data);
  }

  static getBlocos (tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc) {
    return httpRequest(
      `cassetes?tecnicoId=${tecnico}&dataInicio=${dataInicial}&dataFim=${dataFinal}&status=F&nrExame=${numeroDoExame}&numeroPedido=${numeroDoPedido}&citologia=false&sortAsc=${sortAsc}`
    ).then(json => json.data);
  }

  static getLaminas (tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc) {
    return httpRequest(
      `lamina?tecnicoId=${tecnico}&dataInicio=${dataInicial}&dataFim=${dataFinal}&nrExame=${numeroDoExame}&numeroPedido=${numeroDoPedido}&sortAsc=${sortAsc}`
    ).then(json => json.data);
  }

  static getLaminasPorLaudoId (laudo, exibirCanceladas) {
    let exibirCanceladasRequest = exibirCanceladas ? exibirCanceladas : false;
    return httpRequest(
      `lamina?laudo=${laudo}&exibirCanceladas=${exibirCanceladasRequest}`
    ).then(json => json.data);
  }

  static updateLamina (laminaID, status) {
    return httpRequest(
			`lamina/${laminaID}/update/status/${status}`,
			'PATCH',
			0
		).then(json => json.data);
  }

  static criarLamina (data) {
    return httpRequest(`lamina/novo`, 'POST', data).then(json => json);
  }

  static cancelarBloco (id) {
    return httpRequest(`cassetes/${id}/cancelar`, 'PATCH').then(
      json => json.data
    );
  }

  static cancelarLamina (id) {
    return httpRequest(`lamina/${id}/cancelar`, 'PATCH').then(
      json => json.data
    );
  }

  static getNaoConformidades () {
    return httpRequest('nconformidades').then(json => json.data);
  }

  static getHistInconformidadesLamina (id) {
    return httpRequest(`lamina/${id}/nconformidades`, 'GET').then(
      json => json.data
    );
  }

  static getHistInconformidadesBlocos (id) {
    return httpRequest(`cassetes/${id}/nconformidades`, 'GET').then(
      json => json.data
    );
  }

  static registrarNaoConformidadeBloco (
    id,
    nconformidade,
    exibirEmLaudo,
    usuarioId,
    etapa
  ) {
    return httpRequest(`cassetes/${id}/nconformidades`, 'POST', {
      id,
      nconformidade,
      exibirEmLaudo,
      usuarioId,
      etapa
    }).then(json => json.data);
  }

  static registrarNaoConformidadeLamina (
    id,
    nconformidade,
    exibirEmLaudo,
    usuarioId,
    etapa
  ) {
    return httpRequest(`lamina/${id}/nconformidades`, 'POST', {
      id,
      nconformidade,
      exibirEmLaudo,
      usuarioId,
      etapa
    }).then(json => json.data);
  }

  static obterLaudoBlocosCriarLaminaCito (nrexame) {
    return httpRequest(`histologia/blocos/nrexame/${nrexame}`, 'GET').then(
      json => json.data
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/histologia/common/histologia.api.js